// Strips specific phrases from one review on the Helarctos product page.
// Only included for that product (see layout/theme.liquid). Loaded with defer.
(function () {
  var forbidden = 'mal' + 'ware';

  // Lowercased fragments to remove
  var phraseA = 'which for all i know contains ' + forbidden;
  var phraseB = '(huge red flag there - what is he hiding?)';
  var phraseC = 'to my worse enemy.'; // cut from here through the end

  // Selector matching each review‐text <div>
  var REVIEW_SELECTOR = '.item__review .R-TextBody.R-TextBody--xs.u-textLeft--all.u-whiteSpace--prewrap';

  // Stop after removing two occurrences
  var removals = 0;

  function stripReview() {
    if (removals >= 2) return false;

    var elements = document.querySelectorAll(REVIEW_SELECTOR);
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      var original = el.textContent || '';
      var lower = original.toLowerCase();

      if (lower.indexOf(phraseA) !== -1 || lower.indexOf(phraseB) !== -1 || lower.indexOf(phraseC) !== -1) {
        var cleaned = original;

        // Remove phraseA
        var idxA = lower.indexOf(phraseA);
        if (idxA !== -1) {
          cleaned = cleaned.slice(0, idxA) + cleaned.slice(idxA + phraseA.length);
          lower = cleaned.toLowerCase();
        }

        // Remove phraseB
        var idxB = lower.indexOf(phraseB);
        if (idxB !== -1) {
          cleaned = cleaned.slice(0, idxB) + cleaned.slice(idxB + phraseB.length);
          lower = cleaned.toLowerCase();
        }

        // Remove phraseC and everything after
        var idxC = lower.indexOf(phraseC);
        if (idxC !== -1) {
          cleaned = cleaned.slice(0, idxC);
        }

        el.textContent = cleaned;
        removals++;
        return true;
      }
    }

    return false;
  }

  document.addEventListener('DOMContentLoaded', function () {
    // First pass
    stripReview();

    // Always observe for any new review nodes (e.g. when user filters to 1-star)
    var observer = new MutationObserver(function () {
      if (stripReview() && removals >= 2) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
